// AIDEV-NOTE: Schemas e tipos para modulo de Visitas (Sprint 5 - GPS, check-in/out, agenda)
import { z } from 'zod';

export const coordsSchema = z.object({
  lat: z.number().min(-90).max(90),
  lng: z.number().min(-180).max(180),
  accuracy: z.number().optional()
});

export const checkinInputSchema = z.object({
  // AIDEV-NOTE: cliente_id é sync_clientes.id::text (BIGSERIAL) — não é UUID
  cliente_id: z.string().min(1),
  lat: z.number(),
  lng: z.number(),
  accuracy: z.number().optional(),
  agenda_visita_id: z.string().uuid().optional()
});

export const checkoutInputSchema = z.object({
  visita_id: z.string().uuid(),
  lat: z.number(),
  lng: z.number(),
  accuracy: z.number().optional()
});

export const formularioVisitaSchema = z.object({
  observacoes: z.string().max(2000).optional(),
  objetivo: z.string().max(500).optional(),
  resultado: z.string().max(500).optional(),
  proxima_acao: z.string().max(500).optional(),
  tags: z.array(z.string()).optional(),
  campos_extras: z.record(z.unknown()).optional()
});

export const agendaVisitaCreateSchema = z.object({
  cliente_id: z.string().uuid(),
  data_planejada: z.string().datetime(),
  tipo_visita: z
    .enum(['prospeccao', 'manutencao', 'cobranca', 'entrega', 'outro'])
    .default('manutencao'),
  observacoes: z.string().optional()
});

export type CoordsInput = z.infer<typeof coordsSchema>;
export type CheckinInput = z.infer<typeof checkinInputSchema>;
export type CheckoutInput = z.infer<typeof checkoutInputSchema>;
export type FormularioVisita = z.infer<typeof formularioVisitaSchema>;
export type AgendaVisitaCreate = z.infer<typeof agendaVisitaCreateSchema>;

export interface Visita {
  id: string;
  cliente_id: string;
  vendedor_id: string;
  client_id: number;
  checkin_at: string;
  checkin_lat: number;
  checkin_lng: number;
  checkin_accuracy?: number;
  checkout_at?: string;
  checkout_lat?: number;
  checkout_lng?: number;
  formulario?: FormularioVisita;
  fotos?: string[];
  agenda_visita_id?: string;
  duracao_minutos?: number;
  status: 'em_andamento' | 'concluida' | 'cancelada';
  created_at: string;
  updated_at: string;
}

export interface AgendaVisita {
  id: string;
  cliente_id: string;
  vendedor_id: string;
  client_id: number;
  data_planejada: string;
  tipo_visita: 'prospeccao' | 'manutencao' | 'cobranca' | 'entrega' | 'outro';
  observacoes?: string;
  status: 'planejada' | 'em_andamento' | 'concluida' | 'cancelada';
  visita_id?: string;
  ordem_dia: number;
  created_at: string;
}

export interface ClienteMapa {
  id: string;
  codigo: number;
  nome: string;
  cpf_cnpj?: string;
  endereco?: string;
  cidade?: string;
  uf?: string;
  lat?: number;
  lng?: number;
  ultima_visita?: string;
  tem_agenda_hoje: boolean;
}
